import { NoImage } from '../../components/NoImage';
import { BalloonImage as BalloonImageComponent } from '../../components/BalloonImage';
import * as styles from './BalloonImage.css';

interface IBalloonImageProps {
  imageUrl?: string | null;
  complexName?: string | null;
}

export function BalloonImage({ imageUrl, complexName }: IBalloonImageProps) {
  if (!imageUrl) {
    return (
      <div className={styles['image-wrapper']}>
        <NoImage />
      </div>
    );
  }

  return (
    <div className={styles['image-wrapper']}>
      <BalloonImageComponent imageUrl={imageUrl} title={complexName || ''} />
    </div>
  );
}
